<template>
  <footer class="footer">
    <div class="footer-nav-wrap">
      <div class="logo"><img src="http://ylxh-service.oss-cn-hangzhou.aliyuncs.com/footer-logo.png" alt="" class="logo-img"></div>
      <div class="menu-content">
        <div class="menu-column">
          <div class="menu-title">通知公告</div>
          <div class="menu-item"><a @click="toPage('/notice')">通知公告</a></div>
          <!-- <div class="menu-item"><a href="">行业新闻</a></div>
          <div class="menu-item"><a href="">公司动态</a></div> -->
        </div>
        <div class="menu-column">
          <div class="menu-title">政策法规</div>
          <div class="menu-item"><a @click="toPage('/policy?aId=4003')">国家标准</a></div>
          <div class="menu-item"><a @click="toPage('/policy?aId=4004')">地方标准</a></div>
          <div class="menu-item"><a @click="toPage('/policy?aId=4005')">团体标准</a></div>
        </div>
        <div class="menu-column">
          <div class="menu-title">电子期刊</div>
          <!-- <div class="menu-item"><a href="">中国园林</a></div>
          <div class="menu-item"><a href="">浙江园林</a></div> -->
        </div>
        <div class="menu-column">
          <div class="menu-title">会员之家</div>
          <div class="menu-item"><a @click="toPage('/member/person/register')">个人会员申请</a></div>
          <div class="menu-item"><a @click="toPage('/member/group/register')">团体会员申请</a></div>
          <!-- <div class="menu-item"><a href="">会费缴纳</a></div>
          <div class="menu-item"><a href="">招聘岗位</a></div> -->
        </div>
        <div class="menu-column">
          <div class="menu-title">友情链接</div>
          <div class="menu-item"><a href="https://jst.zj.gov.cn/">浙江省住房和城乡建设厅</a></div>
          <div class="menu-item"><a href="http://www.chsla.org.cn/">中国风景园林学会</a></div>
        </div>
      </div>
      <div class="qrcode">
        <img src="../assets/images/qrcode.jpg" alt="">
        <p>扫码关注公众号</p>
      </div>
    </div>
    <div class="split-line"></div>
    <div class="corpright">
      Copyright © 2022-2025 浙江省风景园林学会  <a href="http://beian.miit.gov.cn/" target="_blank" >浙ICP备2022029097号-1</a> 
    </div>
  </footer>
</template>

<script>
import router from '@/router';
export default {
  methods: {
    toPage(uri) {
      router.push(uri);
    }
  }
}
</script>

<style lang="less" scoped>
@middleWidth: 1200px;

footer.footer {
  width: 100%;
  height: 235px;
  background: #F1F3F3;

  > div {
    width: @middleWidth;
    margin: 0 auto;
  }

  .footer-nav-wrap {
    display: flex;
    padding: 26px 0 21px;
    justify-content: space-between;
    align-items: center;

    .logo {
      height: 64px;

      > img {
        height: 100%;
      }
    }

    .menu-content {
      padding-left: 62px;
      display: flex;
      position: relative;

      &::before {
        content: '';
        width: 2px;
        height: 127px;
        background: #E1E1E1;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }

      .menu-column {
        min-width: 100px;
        max-width: 140px;

        .menu-title {
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #131415;
          line-height: 20px;
          margin-bottom: 16px;
        }

        .menu-item {
          height: 17px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #131415;
          line-height: 17px;
          margin-bottom: 8px;

          > a {
            color: inherit;
            text-decoration: none;

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }

    .qrcode {
      width: 121px;

      > img {
        width: 100%;
        display: block;
        margin-bottom: 7px;
      }

      > p {
        text-align: center;
        height: 17px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #131415;
        line-height: 17px;
      }
    }
  }

  .split-line {
    height: 1px;
    background: #E1E1E1;
  }

  .corpright {
    padding-top: 15px;
    text-align: center;
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #131415;
    line-height: 17px;
  }
}
</style>